import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService } from './toast.service';
import { Toast } from './toast.types';

@Component({
  selector: 'nsc-toast-container',
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './toast.component.scss'
})
export class ToastContainerComponent {
  protected toastService = inject(ToastService);

  // Colores por defecto (coinciden con el SCSS)
  private readonly colors = {
    success: '#10B981',
    error: '#EF4444',
    warning: '#F59E0B',
    info: '#3B82F6'
  };

  /**
   * Determina el color del tema basado en el tipo o el customColor
   */
  getToastColor(toast: Toast): string {
    if (toast.type === 'custom' && toast.customColor) {
      return toast.customColor;
    }
    return this.colors[toast.type as keyof typeof this.colors] || this.colors.info;
  }

  /**
   * Cierra el toast (previene la propagación del click al contenedor)
   */
  closeToast(event: Event, id: string) {
    event.stopPropagation();
    this.toastService.remove(id);
  }

  /**
   * Ejecuta la acción personalizada si existe
   */
  handleToastClick(toast: Toast) {
    if (toast.action) {
      toast.action(toast);
    }
  }
}
